import * as d3 from 'd3';
import { weekRange } from '../../lib/chartHelpers.js';
import Axis from './Axis.js';

export default class WeekAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3
      .axisBottom(this.xScale)
      .ticks(d3.timeSunday)
      .tickFormat(weekRange(this.weekCount, '%m/%d'))
      .tickPadding(20);
  }

  positionText() {
    const {
      chart,
      options: { width, weekCount },
    } = this.props;

    chart
      .selectAll('.week .tick text')
      .attr('transform', `translate(${width / weekCount / 2}, -18)`);

    return this;
  }

  removeLines() {
    const { chart } = this.props;

    chart.selectAll('.week line').remove();
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.week')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.positionText().removeLines();
  }

  build() {
    const {
      chart,
      options: { height },
    } = this.props;
    chart.append('g').attr('class', 'axis week').call(this.axis);

    this.positionText().removeLines();
  }
}
